export const SEARCH_FIELDS = [
  {key: "EMAIL", value: "EMAIL"}
  , {key: "APPLICATION_NUMBER", value: "APPLICATION NUMBER"}
  , {key: "ORDER_KEY", value: "ORDER KEY"}
  , {key: "ORDER_NUMBER", value: "ORDER NUMBER"}
  , {key: "DEVICE_ID", value: "DEVICE ID"}
  , {key: "NAME", value: "NAME"}];

export const NAME_DELIMITER = ",";

export const MESSAGE_SIGNUP_FORGOTPASSWORD = "Please contact your system administrator for assistance.";

export const TOKEN_NOT_AUTHORIZED_ERR_MSG = "Unable to authorize token!";

export const MEID_LABEL = "MEID";
export const PREVIOUS_MEID_LABEL = "Previous MEID";

export const INCORRECT_LOGIN_MSG = "Incorrect login credentials. Please retry.";

export const UNABLE_TO_AUTHORIZE_MSG = "Unable to determine your access. Contact your administrator.";

export const GENERIC_ERROR = "Unable to obtain search results, please try again later.";

export const CUSTOMER_INSIGHTS_REDUX_STORE = "customer_insights_redux_store";

export const chartConfig = {
  labels: [
    'Payments Completed',
    'Payments Remaining',
  ]
};

export const NEXT_PAYMENT_LABEL = "Next Payment";
export const NEXT_PAYMENT_DATE_LABEL = "Next Payment Date";
export const EPO_AMOUNT = "Early Payoff Amount\n(incl overdue amount, if any)";
export const CART_ACCORDION_LABEL = "Cart";
export const QUICKDETAILS_ACCORDION_LABEL = "Quick Details";
export const NO_CODE_RECEIVED_MSG = "I didn't receive a verification code";

// constants for Sessions Integration
export const USERNAME = "username";
export const PASSWORD = "password";
export const POOL = "pool";
export const ACCESSTOKEN = "accessToken";
export const SESSION = "session";
export const MFACODE = "mfaCode";
